module.exports = __webpack_public_path__ + "media/images/application/template/phone-fb36edfd65e2cb792d97cd30c8635c2b.svg";